import React, { useEffect, useState } from "react";
import { thirdparty } from "..";
import { IMAGE_URL } from "../constants";
import { MyContext } from "./MyProvider";
import { Link } from "react-router-dom";
import { BrowserView, MobileView } from "react-device-detect";
import styles from "../css/newsEvents.module.css";
import Slider from "react-slick";
const RecommendedPackage = () => {
  const { addToCart } = MyContext;
  const [data, setData] = useState([]);

  const hendleClick = (pagkage, additionalInfo) => {
    addToCart(pagkage, additionalInfo);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await thirdparty(
          `/packages/get_package_list?pagination=1`
        );

        setData(response.data.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  const settings = {
    rows: 2,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const mobileSettings = {
    rows: 1,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="py-0 py-md-5" style={{ backgroundColor: "#F7F5EF" }}>
      <div className="container">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            margin: "0 auto",
          }}
        >
          <h3
            className="text-center mt-4"
            style={{
              color: "#AF9763",
              fontSize: "28px",
              fontWeight: "500",
            }}
          >
            Health Screening Packages
          </h3>
          {/* <img src="/assets/images/testimonial_under.png" alt="" /> */}
          {/* <img src="/assets/images/Rectangle 32.png" alt="" /> */}
        </div>
        <div className="row mt-0 mt-md-5">
          <div className="col-md-12 right-sp-1">
            <div className="news_section py-4">
              <MobileView className={styles.MobileView}>
                <Slider {...mobileSettings}>
                  {" "}
                  {data.map((pagkage) => (
                    <div
                      className="col-sm-3 mt-3 py-4 px-1"
                      style={{
                        width: "100%",
                        maxWidth: "432px",
                        height: "250px",
                        marginRight: "10px",
                      }}
                    >
                      <Link
                        to={"/packages/" + pagkage.slug}
                        style={{
                          fontSize: "12px",
                          color: "#AF9763",
                          textDecoration: "none",
                        }}
                      >
                        <div
                          key={pagkage.id}
                          className="card d-flex flex-column justify-content-between align-items-start shadow"
                          style={{
                            paddingLeft: "0px",
                            paddingRight: "0px",
                            borderRadius: "14px",
                            boxShadow:
                              "0px 4px 6px rgba(0, 0, 0, 0.1), 0px -4px 6px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          <div
                            className="d-flex justify-content-center align-items-center w-100"
                            style={{ height: "120px" }}
                          >
                            {pagkage.image ? (
                              <img
                                className="img-fluid w-100 h-100"
                                src={IMAGE_URL + "Packagesimg/" + pagkage.image}
                                alt="Bitmap-3"
                                style={{
                                  borderRadius: "16px 16px 0px 0px",
                                  objectFit: "cover",
                                  objectPosition: "center",
                                }}
                                // height={"100%"}
                                // width={"100%"}
                              />
                            ) : (
                              <img
                                //   className="img-fluid"
                                src={
                                  IMAGE_URL +
                                  "Packagesimg/202303221003packages Profile.png"
                                }
                                alt="Bitmap-3"
                                style={{
                                  borderRadius: "16px 16px 0px 0px",
                                  objectFit: "contain",
                                  height: "100%",
                                  width: "100%",
                                }}
                                // height={115}
                                width={"100%"}
                              />
                            )}
                          </div>

                          <div
                            className="card-body d-flex justify-content-start align-items-center make-packages-orange w-100"
                            style={{
                              backgroundColor: "#E6DFCF",
                              height: "75px",
                              // borderRadius: "0px 0px 16px 16px",
                            }}
                          >
                            <h5
                              className="card-text"
                              style={{
                                fontSize: "15px",
                                // color: "#af9763",
                                fontWeight: "700",
                              }}
                            >
                              {pagkage.name}
                            </h5>
                          </div>
                          <div
                            class="card-footer d-flex justify-content-between align-items-center w-100"
                            style={{
                              fontSize: "12px",
                              backgroundColor: "#ffffff",
                              borderBottomLeftRadius: "16px",
                              borderBottomRightRadius: "16px",
                              height: "80px",
                            }}
                          >
                            <h5
                              className="make-packages-price-orange mb-0"
                              style={{
                                fontSize: "15px",
                                // color: "#af9763",
                                fontWeight: "900",
                              }}
                            >
                              BDT {pagkage.ipd_amount}
                            </h5>
                            <Link to={"/packages/" + pagkage.slug}>
                              <div
                                className="make-packages-orange"
                                style={{
                                  borderRadius: "5px",
                                  backgroundColor: "#AF9763",
                                  color: "#ffffff",
                                  fontWeight: "500",
                                }}
                              >
                                <button
                                  style={{
                                    padding: "5px 10px",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    borderRadius: "6px",
                                    fontWeight: "500",
                                    width: "100%",
                                  }}
                                  className="deptBtnFont"
                                >
                                  More Information
                                </button>
                              </div>
                            </Link>
                            {/* <p>
                      <a
                        // className="packagesA"
                        href={"/packages/" + pagkage.slug}
                        style={{
                          fontSize: "12px",
                          color: "#AF9763",
                          textDecoration: "none",
                        }}
                      >
                        <b>More Information</b>
                      </a>
                    </p> */}
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </Slider>
              </MobileView>
              <BrowserView className="px-0">
                <Slider className="row" {...settings}>
                  {data.map((pagkage) => (
                    <div
                      className="col-sm-3 px-2 mt-3"
                      style={{
                        width: "100%",
                        maxWidth: "432px",
                        height: "300px",
                        marginRight: "10px",
                      }}
                    >
                      <Link
                        to={"/packages/" + pagkage.slug}
                        style={{
                          fontSize: "12px",
                          color: "#AF9763",
                          textDecoration: "none",
                        }}
                      >
                        <div
                          key={pagkage.id}
                          className="card d-flex flex-column justify-content-between align-items-start shadow"
                          style={{
                            paddingLeft: "0px",
                            paddingRight: "0px",
                            borderRadius: "14px",
                          }}
                        >
                          <div
                            className="d-flex justify-content-center align-items-center w-100"
                            style={{ height: "150px" }}
                          >
                            {pagkage.image ? (
                              <img
                                className="img-fluid w-100 h-100"
                                src={IMAGE_URL + "Packagesimg/" + pagkage.image}
                                alt="Bitmap-3"
                                style={{
                                  borderRadius: "16px 16px 0px 0px",
                                  objectFit: "cover",
                                  objectPosition: "center",
                                }}
                                // height={"100%"}
                                // width={"100%"}
                              />
                            ) : (
                              <img
                                //   className="img-fluid"
                                src={
                                  IMAGE_URL +
                                  "Packagesimg/202303221003packages Profile.png"
                                }
                                alt="Bitmap-3"
                                style={{
                                  borderRadius: "16px 16px 0px 0px",
                                  objectFit: "contain",
                                  height: "100%",
                                  width: "100%",
                                }}
                                // height={115}
                                width={"100%"}
                              />
                            )}
                          </div>

                          <div
                            className="card-body d-flex justify-content-start align-items-center make-packages-orange w-100"
                            style={{
                              backgroundColor: "#E6DFCF",
                              height: "75px",
                              // borderRadius: "0px 0px 16px 16px",
                            }}
                          >
                            <h5
                              className="card-text"
                              style={{
                                fontSize: "18px",
                                // color: "#af9763",
                                fontWeight: "700",
                              }}
                            >
                              {pagkage.name}
                            </h5>
                          </div>
                          <div
                            class="card-footer d-flex justify-content-between align-items-center w-100"
                            style={{
                              fontSize: "12px",
                              backgroundColor: "#ffffff",
                              borderBottomLeftRadius: "16px",
                              borderBottomRightRadius: "16px",
                              height: "80px",
                            }}
                          >
                            <h5
                              className="make-packages-price-orange mb-0"
                              style={{
                                fontSize: "18px",
                                // color: "#af9763",
                                fontWeight: "900",
                              }}
                            >
                              BDT {pagkage.ipd_amount}
                            </h5>
                            <Link to={"/packages/" + pagkage.slug}>
                              <div
                                className="make-packages-orange"
                                style={{
                                  borderRadius: "5px",
                                  backgroundColor: "#AF9763",
                                  color: "#ffffff",
                                  fontWeight: "500",
                                }}
                              >
                                <button
                                  style={{
                                    padding: "5px 10px",
                                    color: "#fff",
                                    textTransform: "capitalize",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    borderRadius: "6px",
                                    fontWeight: "500",
                                    width: "100%",
                                  }}
                                  className="deptBtnFont"
                                >
                                  More Information
                                </button>
                              </div>
                            </Link>
                            {/* <p>
                      <a
                        // className="packagesA"
                        href={"/packages/" + pagkage.slug}
                        style={{
                          fontSize: "12px",
                          color: "#AF9763",
                          textDecoration: "none",
                        }}
                      >
                        <b>More Information</b>
                      </a>
                    </p> */}
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))}
                </Slider>
              </BrowserView>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendedPackage;



// WEBPACK FOOTER //
// ./src/component/RecommendedPackage.js